module.exports = __webpack_public_path__ + "static/media/bullet-inactiv.be3a2159.png";